import { Icon } from '@iconify/react';
import type { FileItem } from '../../common/schema/schemaType';
interface FileIconProps {
    file: FileItem;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}
export default function FileIcon({ file, size = 'md', className = '' }: FileIconProps) {
    const sizeClasses = {
        sm: 'w-4 h-4 text-sm',
        md: 'w-5 h-5 text-base',
        lg: 'w-6 h-6 text-lg'
    };
    const getIconAndColor = (file: FileItem) => {
        if (file.type === 'folder') {
            return { icon: 'lucide:folder', color: 'text-[#4CAF50]' };
        }
        const ext = file.extension?.toLowerCase();
        switch (ext) {
            case 'pdf':
                return { icon: 'lucide:file-text', color: 'text-[#FF9800]' };
            case 'doc':
            case 'docx':
                return { icon: 'lucide:file-text', color: 'text-[#FF9800]' };
            case 'xls':
            case 'xlsx':
                return { icon: 'lucide:file-spreadsheet', color: 'text-[#009688]' };
            case 'ppt':
            case 'pptx':
                return { icon: 'lucide:presentation', color: 'text-[#FF9800]' };
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'webp':
                return { icon: 'lucide:image', color: 'text-[#9C27B0]' };
            case 'mp4':
            case 'avi':
            case 'mov':
            case 'wmv':
                return { icon: 'lucide:video', color: 'text-[#9C27B0]' };
            case 'mp3':
            case 'wav':
            case 'flac':
                return { icon: 'lucide:music', color: 'text-[#9C27B0]' };
            case 'zip':
            case 'rar':
            case '7z':
                return { icon: 'lucide:archive', color: 'text-[#5A6C7D]' };
            case 'txt':
                return { icon: 'lucide:file-text', color: 'text-[#5A6C7D]' };
            default:
                return { icon: 'lucide:file', color: 'text-[#5A6C7D]' };
        }
    };
    const { icon, color } = getIconAndColor(file);
    return (<div className={`flex items-center justify-center bg-transparent ${sizeClasses[size]} ${className}`} data-id="wepcfi">
      <Icon icon={icon} className={`${sizeClasses[size]} ${color}`} data-id="mm58tp"/>
    </div>);
}
